import * as React from "react";
import { cs } from "@Common/react/chain-services"

import "./pickup-address.scss";

export const PickupAddress = ({}) => cs(

    ({}) => (
            <div className="pickup-address pickup-address-3rg" xd-qa-type="card" xd-qa-name="Pickup Address">
                <div className="card">
                    <i className="fa fa-map-marker" xd-qa-type="icon" xd-qa-name="Pickup Address Icon"/>
                    <div className="address">
                        <div className="text" xd-qa-type="label" xd-qa-name="Pickup Address Text">
                            1301 NE Loop 820, Fort Worth, TX 76131
                        </div>
                        <div className="description" xd-qa-type="label" xd-qa-name= "Pickup Address Description">
                            Pickup Location
                        </div>
                    </div>
                </div>
            </div>
        ),

);
